import React from 'react';
import { ImpDivider, ImpFlex, ImpPad, ImpText, colors, spacing } from '../..';
export default function ImpListHeader({ title, subtitle, trailingTitleContent, borderBottom = true, variant = 'default', }) {
    const typography = variant === 'small' ? 'label1' : 'headline3';
    const color = variant === 'small'
        ? colors.content.onSurfaceVariant
        : colors.content.onSurface;
    return (React.createElement(ImpPad, { padding: `0px ${spacing.l}`, dataTestId: "header-pad" },
        React.createElement(ImpPad, { padding: `${spacing.l} 0px` },
            React.createElement(ImpFlex, { fluid: true, justify: "space-between", dataTestId: "header-content", direction: "column" },
                React.createElement(ImpFlex, { fluid: true, justify: "space-between", align: "center", dataTestId: "header-content-title" },
                    React.createElement(ImpText, { typography: typography, color: color, dataTestId: "header-title", handleSuperscript: true }, title),
                    trailingTitleContent),
                subtitle && (React.createElement(ImpText, { typography: "body2", color: colors.content.onBackgroundVariant, dataTestId: "header-subtitle" }, subtitle)))),
        borderBottom && React.createElement(ImpDivider, { color: colors.border.borderVariant })));
}
//# sourceMappingURL=ImpListHeader.js.map